import React, { useEffect, useState } from 'react';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import axios from 'axios';
import carIcon from '../../assets/images/car.png'; // Adjust the path based on your project structure

const MapComponent = () => {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDriver, setSelectedDriver] = useState(null); // State to manage selected driver
  const apiKey = 'AIzaSyAlH18xpqa_pLDIipmeDfVKet9HN8sPQM0'; // Replace with your actual API key

  useEffect(() => {
    const fetchActiveDrivers = async () => {
      try {
        const response = await axios.get('http://93.127.203.113:5005/drivers/activeDrivers');
        setDrivers(response.data.activeDrivers);
      } catch (error) {
        console.error('Error fetching active drivers:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchActiveDrivers();
  }, []);

  const center = {
    lat: drivers.length > 0 ? parseFloat(drivers[0].currentLat) : 9.03, // Default lat if no driver
    lng: drivers.length > 0 ? parseFloat(drivers[0].currentLon) : 38.76, // Default lng if no driver
  };

  return (
    <LoadScript googleMapsApiKey={apiKey}>
      <GoogleMap
        mapContainerStyle={{ height: '100vh', width: '100%' }} // Full height and width
        center={center}
        zoom={12}
      >
        {loading && <div>Loading...</div>}
        {drivers.map(driver => (
          <Marker
            key={driver.id}
            position={{
              lat: parseFloat(driver.currentLat),
              lng: parseFloat(driver.currentLon),
            }}
            icon={{
              url: carIcon, // Use the imported local icon
              scaledSize: new window.google.maps.Size(40, 40), // Increase size of the icon
            }}
            title={`${driver.firstName} ${driver.lastName}`}
            onClick={() => setSelectedDriver(driver)} // Set selected driver on click
          />
        ))}
        {selectedDriver && (
          <InfoWindow
            position={{
              lat: parseFloat(selectedDriver.currentLat),
              lng: parseFloat(selectedDriver.currentLon),
            }}
            onCloseClick={() => setSelectedDriver(null)}
          >
            <div>
              <h2>{`${selectedDriver.firstName} ${selectedDriver.lastName}`}</h2>
              <p>ID: {selectedDriver.driverId}</p>
              <p>Status: {selectedDriver.status}</p>
              <p>Phone: {selectedDriver.phoneNumber}</p>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </LoadScript>
  );
};

export default MapComponent;
